import { useEffect, useState } from "react";
import { addUpdateManagePermission, fetchManagePermission } from "../../../utils/api/managePermissionApi";
import { getCompanyId } from "../../../utils/utilityFunctions/localServices";
import { pushAlert } from "../../../utils/alertSlice";
import { useDispatch } from "react-redux";
import ToggleSwitch from "../../UniversalComponents/SwitchButton";
import LabelComponent from "../../UniversalComponents/LabelComponent";
import InputComponent from "../../UniversalComponents/InputComponent";
import { hideLoader, showLoader } from "../../../utils/loaderSlice";

const PermissionModuleOptions = ({
  formData,
  setFormData,
  setErrorFields,
  errorFields,
  refetchApi,
  onClose,
  permissionsTableData,
}) => {
  const dispatch = useDispatch();

  const [isApiLoading, setIsApiLoading] = useState(false);

  const handleSwitchUpdate = (item, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      organisationView: prevFormData?.organisationView?.map((data) => {
        if (data.module_id === item.module_id) {
          return { ...data, module_permission: value ? 1 : 0 };
        }
        return data;
      }),
    }));
  };

  const handleOrganisationSubmit = async (e) => {
    e.preventDefault();

    let isError = false;
    setIsApiLoading(true);
    try {
      if (formData?.name === "" || formData?.name === undefined || formData?.name === null) {
        setErrorFields((prev) => ({ ...prev, name: "Field is required" }));
        isError = true;
      }

      if (!isError) {
        const body = {
          company_id: getCompanyId(),
          permission_name: formData?.name,
          permission_description: formData?.description,
          modules: formData?.organisationView,
        };

        // TO Update the record
        if (formData?.permission_id) {
          body.permission_id = formData?.permission_id;
        }

        const response = await addUpdateManagePermission({ body });

        if (response?.success) {
          refetchApi();

          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "success",
            })
          );
          setErrorFields({ name: "", description: "" });
          onClose();
        } else {
          dispatch(
            pushAlert({
              visible: true,
              type: "danger",
              message: response?.message || "Something went wrong",
            })
          );
        }
      } else {
        dispatch(
          pushAlert({
            visible: true,
            type: "danger",
            message: "Please fill all the required fields.",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          type: "danger",
          message: error?.message,
        })
      );
    } finally {
      setIsApiLoading(false);
    }
  };

  const handleFieldChange = (e) => {
    const { name, value, label } = e.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    if (name === "name") {
      checkIfUserNameExist(value);
    }
  };

  const callAPI = async () => {
    setIsApiLoading(true);
    const permissionModuleResponse = await fetchManagePermission({
      query: {
        company_id: getCompanyId(),
        key: "all_modules",
      },
    });

    setFormData((prevFormData) => ({
      ...prevFormData,
      organisationView:
        prevFormData?.organisationView?.length > 0 ? prevFormData?.organisationView : permissionModuleResponse?.data,
    }));

    setIsApiLoading(false);
  };

  const checkIfUserNameExist = (text) => {
    const isFound = permissionsTableData?.find((item) => {
      return item?.permission_name?.toLowerCase() === text?.toLowerCase();
    });
    if (isFound?.name) {
      setErrorFields((prev) => ({ ...prev, name: "Name already exists" }));
    } else if (isFound?.name == "" || isFound?.name == undefined || isFound?.name == null) {
      setErrorFields((prev) => ({ ...prev, name: "Feild is required" }));
    } else {
      setErrorFields((prev) => ({ ...prev, name: false }));
    }
  };

  useEffect(() => {
    callAPI();
  }, []);

  useEffect(() => {
    if (isApiLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isApiLoading]);

  return (
    <>
      <div className="w-full h-full shadow-md rounded-md border-[1px] bg-white border-BECBD3  p-3">
        <div className="w-full lg:w-[100%] h-full flex flex-col gap-4 rounded-md border-[1px] bg-white border-BECBD3">
          <form className="w-full flex gap-3 p-4 pb-0" onSubmit={() => {}}>
            <div className="w-full flex flex-col">
              <LabelComponent labelText="Name" isMandatory={true} />
              <InputComponent
                mandatory={true}
                value={formData?.name}
                name="name"
                onChange={handleFieldChange}
                placeholder="Enter Name"
                error={errorFields?.name ? true : false}
              />
            </div>
            <div className="w-full flex flex-col">
              <LabelComponent labelText="Description" isMandatory={false} />
              <InputComponent
                value={formData?.description}
                name="description"
                onChange={handleFieldChange}
                placeholder="Enter Description"
              />
            </div>
          </form>
          <hr className="mx-4" />
          <div className="w-full h-full flex flex-col justify-between gap-4">
            <div className="w-full flex flex-col gap-2 px-4">
              {formData?.organisationView?.map((item) => {
                return (
                  <div key={item?.module_id} className="w-full flex justify-between items-center">
                    <p className="">{item?.module_name}</p>
                    <ToggleSwitch
                      checked={Boolean(item?.module_permission)}
                      onChange={(value) => {
                        handleSwitchUpdate(item, value);
                      }}
                    />
                  </div>
                );
              })}
            </div>

            <div className="w-full flex justify-end items-center gap-4 p-4 border-[1px] border-t-BECBD3 border-b-0 border-r-0 border-l-0">
              <div className="w-fit flex gap-4">
                <button onClick={onClose} className="bg-[#D2DAE1] text-[#383838] min-w-[100px] rounded-md py-2 px-6">
                  Cancel
                </button>
                <button
                  onClick={handleOrganisationSubmit}
                  className="bg-[#1D4469] text-white min-w-[100px] rounded-md py-2 px-6 "
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PermissionModuleOptions;
